/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UndercarriagePartConditionResponse } from './UndercarriagePartConditionResponse';
import {
    UndercarriagePartConditionResponseFromJSON,
    UndercarriagePartConditionResponseFromJSONTyped,
    UndercarriagePartConditionResponseToJSON,
    UndercarriagePartConditionResponseToJSONTyped,
} from './UndercarriagePartConditionResponse';
import type { UndercarriageWearHistoryResponse } from './UndercarriageWearHistoryResponse';
import {
    UndercarriageWearHistoryResponseFromJSON,
    UndercarriageWearHistoryResponseFromJSONTyped,
    UndercarriageWearHistoryResponseToJSON,
    UndercarriageWearHistoryResponseToJSONTyped,
} from './UndercarriageWearHistoryResponse';
import type { UndercarriageManufacturerResponse } from './UndercarriageManufacturerResponse';
import {
    UndercarriageManufacturerResponseFromJSON,
    UndercarriageManufacturerResponseFromJSONTyped,
    UndercarriageManufacturerResponseToJSON,
    UndercarriageManufacturerResponseToJSONTyped,
} from './UndercarriageManufacturerResponse';
import type { UndercarriageReportPhotoResponse } from './UndercarriageReportPhotoResponse';
import {
    UndercarriageReportPhotoResponseFromJSON,
    UndercarriageReportPhotoResponseFromJSONTyped,
    UndercarriageReportPhotoResponseToJSON,
    UndercarriageReportPhotoResponseToJSONTyped,
} from './UndercarriageReportPhotoResponse';

/**
 * 
 * @export
 * @interface UndercarriageReportDataResponse
 */
export interface UndercarriageReportDataResponse {
    /**
     * 
     * @type {number}
     * @memberof UndercarriageReportDataResponse
     */
    inspectionId?: number;
    /**
     * 
     * @type {Date}
     * @memberof UndercarriageReportDataResponse
     */
    inspectionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    assetName?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    inspectorName?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    commodity?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    siteDiggingConditions?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    totalMachineHours?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    totalPropelHours?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    undercarriageHoursLeft?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    undercarriageHoursRight?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    undercarriagePropelHoursLeft?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    undercarriagePropelHoursRight?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    hoursSinceLastInspection?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    executiveSummary?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    sideFrameCommentLeft?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageReportDataResponse
     */
    sideFrameCommentRight?: string;
    /**
     * 
     * @type {Array<UndercarriageManufacturerResponse>}
     * @memberof UndercarriageReportDataResponse
     */
    manufacturers?: Array<UndercarriageManufacturerResponse>;
    /**
     * 
     * @type {Array<UndercarriageReportPhotoResponse>}
     * @memberof UndercarriageReportDataResponse
     */
    photos?: Array<UndercarriageReportPhotoResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UndercarriageReportDataResponse
     */
    annotations?: Array<string>;
    /**
     * 
     * @type {Array<UndercarriageWearHistoryResponse>}
     * @memberof UndercarriageReportDataResponse
     */
    wearHistory?: Array<UndercarriageWearHistoryResponse>;
    /**
     * 
     * @type {Array<UndercarriagePartConditionResponse>}
     * @memberof UndercarriageReportDataResponse
     */
    parts?: Array<UndercarriagePartConditionResponse>;
}

/**
 * Check if a given object implements the UndercarriageReportDataResponse interface.
 */
export function instanceOfUndercarriageReportDataResponse(value: object): value is UndercarriageReportDataResponse {
    return true;
}

export function UndercarriageReportDataResponseFromJSON(json: any): UndercarriageReportDataResponse {
    return UndercarriageReportDataResponseFromJSONTyped(json, false);
}

export function UndercarriageReportDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageReportDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'inspectionId': json['inspectionId'] == null ? undefined : json['inspectionId'],
        'inspectionDate': json['inspectionDate'] == null ? undefined : (new Date(json['inspectionDate'])),
        'assetName': json['assetName'] == null ? undefined : json['assetName'],
        'inspectorName': json['inspectorName'] == null ? undefined : json['inspectorName'],
        'commodity': json['commodity'] == null ? undefined : json['commodity'],
        'siteDiggingConditions': json['siteDiggingConditions'] == null ? undefined : json['siteDiggingConditions'],
        'totalMachineHours': json['totalMachineHours'] == null ? undefined : json['totalMachineHours'],
        'totalPropelHours': json['totalPropelHours'] == null ? undefined : json['totalPropelHours'],
        'undercarriageHoursLeft': json['undercarriageHoursLeft'] == null ? undefined : json['undercarriageHoursLeft'],
        'undercarriageHoursRight': json['undercarriageHoursRight'] == null ? undefined : json['undercarriageHoursRight'],
        'undercarriagePropelHoursLeft': json['undercarriagePropelHoursLeft'] == null ? undefined : json['undercarriagePropelHoursLeft'],
        'undercarriagePropelHoursRight': json['undercarriagePropelHoursRight'] == null ? undefined : json['undercarriagePropelHoursRight'],
        'hoursSinceLastInspection': json['hoursSinceLastInspection'] == null ? undefined : json['hoursSinceLastInspection'],
        'executiveSummary': json['executiveSummary'] == null ? undefined : json['executiveSummary'],
        'sideFrameCommentLeft': json['sideFrameCommentLeft'] == null ? undefined : json['sideFrameCommentLeft'],
        'sideFrameCommentRight': json['sideFrameCommentRight'] == null ? undefined : json['sideFrameCommentRight'],
        'manufacturers': json['manufacturers'] == null ? undefined : ((json['manufacturers'] as Array<any>).map(UndercarriageManufacturerResponseFromJSON)),
        'photos': json['photos'] == null ? undefined : ((json['photos'] as Array<any>).map(UndercarriageReportPhotoResponseFromJSON)),
        'annotations': json['annotations'] == null ? undefined : json['annotations'],
        'wearHistory': json['wearHistory'] == null ? undefined : ((json['wearHistory'] as Array<any>).map(UndercarriageWearHistoryResponseFromJSON)),
        'parts': json['parts'] == null ? undefined : ((json['parts'] as Array<any>).map(UndercarriagePartConditionResponseFromJSON)),
    };
}

export function UndercarriageReportDataResponseToJSON(json: any): UndercarriageReportDataResponse {
    return UndercarriageReportDataResponseToJSONTyped(json, false);
}

export function UndercarriageReportDataResponseToJSONTyped(value?: UndercarriageReportDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inspectionId': value['inspectionId'],
        'inspectionDate': value['inspectionDate'] == null ? undefined : ((value['inspectionDate']).toISOString()),
        'assetName': value['assetName'],
        'inspectorName': value['inspectorName'],
        'commodity': value['commodity'],
        'siteDiggingConditions': value['siteDiggingConditions'],
        'totalMachineHours': value['totalMachineHours'],
        'totalPropelHours': value['totalPropelHours'],
        'undercarriageHoursLeft': value['undercarriageHoursLeft'],
        'undercarriageHoursRight': value['undercarriageHoursRight'],
        'undercarriagePropelHoursLeft': value['undercarriagePropelHoursLeft'],
        'undercarriagePropelHoursRight': value['undercarriagePropelHoursRight'],
        'hoursSinceLastInspection': value['hoursSinceLastInspection'],
        'executiveSummary': value['executiveSummary'],
        'sideFrameCommentLeft': value['sideFrameCommentLeft'],
        'sideFrameCommentRight': value['sideFrameCommentRight'],
        'manufacturers': value['manufacturers'] == null ? undefined : ((value['manufacturers'] as Array<any>).map(UndercarriageManufacturerResponseToJSON)),
        'photos': value['photos'] == null ? undefined : ((value['photos'] as Array<any>).map(UndercarriageReportPhotoResponseToJSON)),
        'annotations': value['annotations'],
        'wearHistory': value['wearHistory'] == null ? undefined : ((value['wearHistory'] as Array<any>).map(UndercarriageWearHistoryResponseToJSON)),
        'parts': value['parts'] == null ? undefined : ((value['parts'] as Array<any>).map(UndercarriagePartConditionResponseToJSON)),
    };
}

